var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('h1',[_vm._v("Your weekly roundup")]),_c('div',{staticClass:"widget"},[_c('briefs-chart',{attrs:{"options":{responsive: false, maintainAspectRatio: false},"width":400,"height":100}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }